<template>
  <el-row>
    <el-form :model="editFriendForm"
             ref="editFriendRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction=""
             editAction="friend/editFriend.action"
             selectAction="friend/selectFriendDetail.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item  label="昵称" prop="name">
      <el-input  v-model="editFriendForm.name"></el-input>
      </el-form-item>
      <el-form-item label="微信号" prop="wechat">
      <el-input v-model="editFriendForm.wechat"></el-input>
      </el-form-item>
      <el-form-item  label="手机号" prop="phone">
      <el-input v-model="editFriendForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="imgs">
        <draggable v-model="editFriendForm.imgs" tag="ul" class="img-temp-list" draggable=".img-temp-item">
          <li class="img-temp-item" v-for="(item, i) in editFriendForm.imgs" :key="i">
            <img :src="item.url" />
            <div class="img-action">
              <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
              <i class="el-icon-delete" @click="removeFile(editFriendForm.imgs,i)"></i>
            </div>
          </li>
          <el-upload
              :show-file-list="false"
              :before-upload="(file) => beforeAvatarUpload(file)"
              :data="{floder:'localCarBusinessIntranet/friend'}"
              :file-list="editFriendForm.imgs"
              :http-request="onHttpRequest"
              :limit="9"
              accept="image/*"
              action="upload/uploadPic"
              list-type="picture-card"
              multiple
              ref="imgs"
              v-model="editFriendForm.imgs">

            <i class="el-icon-plus"></i>
          </el-upload>

        </draggable>
        <p style="color:#666;"><span style="color:red;">最多9张</span></p>
      </el-form-item>
      <el-form-item  label="内容" prop="content">
        <el-input type="textarea" v-model="editFriendForm.content"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  name: 'editFriend',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules: {
      },
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      baseSmalIcon: 'ClueDistribution/fdjxtb.png',
      editFriendForm: {
        id: null,
        name: null,
        content: null,
        phone: null,
        wechat: null,
        imgs: []

      }
    }
  },
  created () {
    debugger
    this.editFriendForm.id = this.$route.query.id
  },
  methods: {
    onFilterParams: function (params) {
    },
    onSelectInfo: function (dataInfo) {
      debugger
    },
    removeFile (list, index) {
      list.splice(index, 1)
    },
    beforeAvatarUpload (file) {
      debugger
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传图片大小不能超过 15MB!')
          reject(new Error('上传图片大小不能超过 15MB!'))
          return
        }

        if (_this.editFriendForm.imgs.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张!'))
          return
        }
        resolve()
      })
      return promise
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
